"use client";

// src/react.tsx
import { useEffect } from "react";

// package.json
var name = "@dub/analytics";
var version = "0.0.23";

// src/utils.tsx
function isBrowser() {
  return typeof window !== "undefined";
}

// src/generic.ts
function inject(props) {
  var _a, _b;
  if (!isBrowser())
    return;
  const src = ((_a = props.scriptProps) == null ? void 0 : _a.src) || "https://www.dubcdn.com/analytics/script.js";
  if (document.head.querySelector(`script[src*="${src}"]`))
    return;
  const script = document.createElement("script");
  script.src = src;
  script.defer = ((_b = props.scriptProps) == null ? void 0 : _b.defer) || true;
  script.setAttribute("data-sdkn", name);
  script.setAttribute("data-sdkv", version);
  if (props.apiHost) {
    script.setAttribute("data-api-host", props.apiHost);
  }
  if (props.shortDomain) {
    script.setAttribute("data-short-domain", props.shortDomain);
  }
  if (props.attributionModel) {
    script.setAttribute("data-attribution-model", props.attributionModel);
  }
  if (props.cookieOptions && Object.keys(props.cookieOptions).length > 0) {
    script.setAttribute(
      "data-cookie-options",
      JSON.stringify(props.cookieOptions)
    );
  }
  if (props.queryParam) {
    script.setAttribute("data-query-param", props.queryParam);
  }
  if (props.scriptProps) {
    Object.assign(script, props.scriptProps);
  }
  script.onerror = () => {
    console.log(`[Dub Web Analytics] failed to load script from ${src}.`);
  };
  document.head.appendChild(script);
}

// src/react.tsx
function Analytics(props) {
  useEffect(() => {
    inject(props);
  }, [props]);
  return null;
}
export {
  Analytics
};
//# sourceMappingURL=index.js.map